import React from "react";

const McsIcCheckGreen = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Phosphor / line / Check">
        <path
          id="Vector"
          d="M27 9L13 23L6 16"
          stroke="#12B76A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default McsIcCheckGreen;
